import { WebPlugin } from '@capacitor/core';
export class ReaderWeb extends WebPlugin {
    async open() {
        throw this.unavailable('Not available on web. launch with regular web apis instead');
    }
}
//# sourceMappingURL=web.js.map